import React from 'react';
import { Card, T, ChipGroupField } from '../fields';
import { CHIP_GROUPS } from '../../../utils/portalPageModel';

/*
 * STRENGTHS + TAGS — the three chip groups on the one vocabulary (`CHIP_GROUPS` in
 * utils/portalPageModel), drawn by the shared ChipGroupField that Onboarding v2's step 3 uses.
 * STRENGTHS caps at four; DOWN FOR keeps a legacy pick rendered so it can be removed and carries
 * the SENSUAL & INTIMATE visibility toggle.
 */
export default function TagsTab({ d, upd, phone }) {
  const toggle = (key) => (label) => upd((s) => ({ [key]: s[key].includes(label) ? s[key].filter((x) => x !== label) : [...s[key], label] }));
  return CHIP_GROUPS.map((g) => (
    <Card key={g.key} phone={phone} data-testid={`tags-${g.key}`} style={{ gap: 12 }}>
      <span style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
        <span style={T.title}>{g.title}</span>
        <span style={T.count}>{g.max ? `${d[g.key].length} / ${g.max}` : String(d[g.key].length)}</span>
      </span>
      <span style={T.help}>{g.sub}</span>
      <ChipGroupField
        picked={d[g.key]}
        chips={g.chips}
        max={g.max}
        bg={g.bg}
        fg={g.fg}
        onToggle={toggle(g.key)}
        sensual={g.key === 'downFor' ? { on: d.sensualVisible, onToggle: () => upd({ sensualVisible: !d.sensualVisible }) } : undefined}
      />
    </Card>
  ));
}
